import { useState, useEffect } from "react";
import { fetchBlogServices } from "../api/BlogApi";

export const useBlog = () => {
  const [blogData, setBlogData] = useState([]); // Store all fetched blogs
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1); // Track the current page
  const [hasMore, setHasMore] = useState(true); // Track if more blogs exist

  const getBlogData = async (pageNum) => {
    try {
      setLoading(true);
      const data = await fetchBlogServices(pageNum);
      
      if (data.data.length < 8) {
        setHasMore(false); // If less than 8 blogs are fetched, stop loading more
      }

      setBlogData((prev) => [...prev, ...data.data]); // Append new blogs
      setLoading(false);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    getBlogData(page);
  }, [page]);

  const loadMoreBlogs = () => {
    if (hasMore) {
      setPage((prevPage) => prevPage + 1); // Increase page number on "See All" click
    }
  };

  return { blogData, loading, error, loadMoreBlogs, hasMore };
};